import React from "react";
import "../../styles/team.css";
import yenyLiscano from "../../images/yeny-liscano.png"; 
import exvin from "../../images/exvin.png"; 
import protash from "../../images/protash.png"; 

const clients = [
  {
    imgUrl: yenyLiscano,
    title: "Yeny Liscano",
    link: "https://www.instagram.com/yeny_liscano/",
  },
  {
    imgUrl: exvin,
    title: "EXVIN | Intimate Parfum",
    link: "https://www.instagram.com/exvin/",
  },
  {
    imgUrl: protash,
    title: "PROTASH | Vegan Protein",
    link: "https://www.instagram.com/protash_/",
  },
];

const Team = () => {
  return (
    <section className="our__team">
      <div className="container">
        <div className="team__content">
          <h6 className="subtitle">Our Clients</h6>
          <h2>
            Showcase of <span className="highlight">Our Work</span>
          </h2>
        </div>

        <div className="team__wrapper">
          {clients.map((item, index) => (
            <div className="team__item" key={index}>
              <div className="team__img">
                <img src={item.imgUrl} alt={item.title} />
              </div>
              <div className="team__details">
                <h4>{item.title}</h4>
                <a href={item.link} target="_blank" rel="noopener noreferrer">
                  View Profile
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
